module.exports = __webpack_public_path__ + "static/media/calendario.ac5de7eb.png";